import { render, staticRenderFns } from "./DatosPaciente.vue?vue&type=template&id=35a0972e&"
import script from "./DatosPaciente.vue?vue&type=script&lang=js&"
export * from "./DatosPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports